module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CatalogSorting":{"options":{"DefaultSort":"TOP","LatestSort":"Nejnovější","MostSoldSort":"Nejprodávanější","NameSortASC":"A–Z","NameSortDESC":"Z–A","PriceSortASC":"Nejlevnější","PriceSortDESC":"Nejdražší","SearchSort":"Nejrelevantnější"}}}}')
  delete Component.options._Ctor
}
